/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ElementsUserReference,
    ElementsUserReferenceFromJSON,
    ElementsUserReferenceFromJSONTyped,
    ElementsUserReferenceToJSON,
    LDAPServerReference,
    LDAPServerReferenceFromJSON,
    LDAPServerReferenceFromJSONTyped,
    LDAPServerReferenceToJSON,
    MemberPreview,
    MemberPreviewFromJSON,
    MemberPreviewFromJSONTyped,
    MemberPreviewToJSON,
} from './';

/**
 * 
 * @export
 * @interface ElementsGroupDetail
 */
export interface ElementsGroupDetail {
    /**
     * 
     * @type {number}
     * @memberof ElementsGroupDetail
     */
    id: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ElementsGroupDetail
     */
    permissions?: Array<string>;
    /**
     * 
     * @type {Array<MemberPreview>}
     * @memberof ElementsGroupDetail
     */
    readonly membersPreview: Array<MemberPreview>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ElementsGroupDetail
     */
    readonly effectivePermissions: Array<string>;
    /**
     * 
     * @type {Array<ElementsUserReference>}
     * @memberof ElementsGroupDetail
     */
    members?: Array<ElementsUserReference>;
    /**
     * 
     * @type {LDAPServerReference}
     * @memberof ElementsGroupDetail
     */
    ldap?: LDAPServerReference;
    /**
     * 
     * @type {string}
     * @memberof ElementsGroupDetail
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ElementsGroupDetail
     */
    ldapDn?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ElementsGroupDetail
     */
    unixGroupname?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ElementsGroupDetail
     */
    gid?: number | null;
}

export function ElementsGroupDetailFromJSON(json: any): ElementsGroupDetail {
    return ElementsGroupDetailFromJSONTyped(json, false);
}

export function ElementsGroupDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): ElementsGroupDetail {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'permissions': !exists(json, 'permissions') ? undefined : json['permissions'],
        'membersPreview': ((json['members_preview'] as Array<any>).map(MemberPreviewFromJSON)),
        'effectivePermissions': json['effective_permissions'],
        'members': !exists(json, 'members') ? undefined : ((json['members'] as Array<any>).map(ElementsUserReferenceFromJSON)),
        'ldap': !exists(json, 'ldap') ? undefined : LDAPServerReferenceFromJSON(json['ldap']),
        'name': json['name'],
        'ldapDn': !exists(json, 'ldap_dn') ? undefined : json['ldap_dn'],
        'unixGroupname': !exists(json, 'unix_groupname') ? undefined : json['unix_groupname'],
        'gid': !exists(json, 'gid') ? undefined : json['gid'],
    };
}

export function ElementsGroupDetailToJSON(value?: ElementsGroupDetail | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'permissions': value.permissions,
        'members': value.members === undefined ? undefined : ((value.members as Array<any>).map(ElementsUserReferenceToJSON)),
        'ldap': LDAPServerReferenceToJSON(value.ldap),
        'name': value.name,
        'ldap_dn': value.ldapDn,
        'unix_groupname': value.unixGroupname,
        'gid': value.gid,
    };
}


